import BigNumber from 'bignumber.js';
import contractConfiguration from '../../config.json';

export const formatDenominatedNumber = (
  value: string,
  decimals?: number
): number => {
  return new BigNumber(value)
    .dividedBy(new BigNumber(10).pow(decimals ?? 18))
    .toNumber();
};

export const getFarmContractName = (address: string): string => {
  const farm = contractConfiguration.contractConfiguration.farms.filter(
    (f) =>
      f.mainnet.swap_pool_address === address || f.mainnet.address === address
  );
  return farm.length > 0 ? farm[0].name : 'N/A';
};

export const getSwapContractAddress = (farmAddress: string): string => {
  const farm = contractConfiguration.contractConfiguration.farms.filter(
    (f) => f.mainnet.address === farmAddress
  );
  return farm.length > 0 ? farm[0].mainnet.swap_pool_address : '';
};

export const getFarmPartnerLevel = (address: string): string => {
  const farm = contractConfiguration.contractConfiguration.farms.filter(
    (f) =>
      f.mainnet.swap_pool_address === address || f.mainnet.address === address
  );
  return farm.length > 0 ? farm[0].partnerLevel : 'N/A';
};
